<template>
    <b-modal :active.sync="prodDetailModal" scrol="keep" :width="500">
        <b-loading :is-full-page="false" :active.sync="prodDetailLoading" :can-cancel="true"></b-loading>
        <div class="modal-card has-text-centered modal-add-to-list" >
            
            <div class="modal-card-body">
                <div class="has-text-right">
                    <a class="has-text-danger" @click="prodDetailModal=false">
                        <b-icon icon="times " sizes="is-small"></b-icon>
                    </a>
                </div>
                <div class="container">
                    <p class="title">{{product.title}}</p>
                    <p>
                        <span
                        v-if="product.status == 'O'"
                        class="compare-at heading">
                            {{product.currencySymbol}} {{compareAtDisplay}}
                        </span>
                    </p>
                    <p class="m-t-10">
                        <span class="title has-text-centered has-text-success">{{product.currencySymbol}} {{cartItem.unitPrice}}</span> 
                    </p>
                    <p v-for="attr in product.attributes" class="has-text-left" :key="attr.id">
                        <span class="has-text-weight-semibold">{{attr.title}}</span>
                        <b-field>
                            <b-radio-button
                                v-for="val in attr.values"
                                v-model="selectedValues[attr.title]"
                                :key="val.id"
                                :native-value="val.id"
                                type="is-success"
                                @input="attrChange">
                                <span>{{val.title}}</span>
                            </b-radio-button>
                        </b-field>
                    </p>
                    <!-- Product quantity and add to cart button. -->
                    <b-field v-if="!product.classified" class="m-t-20 m-b-10">
                        
                        <b-numberinput
                            :editable="false"
                            rounded
                            constrols-position="compact"
                            v-model="cartItem.quantity"
                            min="1"
                            type="is-light"
                        >
                        </b-numberinput>

                        <p class="control">
                            <b-button
                            :loading="addButtonLoad"
                            class="is-custom"
                            :disabled="saveButtonDisabled"
                            @click="sendItem"
                            >
                            Agregar al pedido
                            </b-button>
                        </p>
                    </b-field>
                    <div class="description-box">
                        <div class="ql-editor" v-html="product.description"></div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import {getHandler, postHandler} from "./../../../../services/http"
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
    props:{
        prodDetailModal:{
            type:Boolean,
            default:false
        },
        product:{
            type:Object,
            default: new Object({})
        },
        saveButtonDisabled:{
            type:Boolean,
            default:false
        },
        prodDetailLoading:{
            type:Boolean,
            default:false
        },
        createCartItemUrl:{
            type:String,
            default:""
        }
    },
     data(){
        return{
            addButtonLoad:false,
            selectedValues:{},
            cartItem:{
                unitPrice:"",
                quantity:1,
                variant:"",
                product:"",
                values:[]
            },
            compareAtDisplay:0,
        }
    },
    methods:{
        attrChange(){
            var arr = []
            for (let index in this.product.attributes){
                var el = this.product.attributes[index]
                if(this.selectedValues[el.title]){
                    arr.push(this.selectedValues[el.title])
                }
            }
            if(this.product.attributes.length == arr.length){
                this.saveButtonDisabled=false
                this.cartItem.values = arr
                let variante = this.product.variants.find(
                    (variant)=>{
                        return variant.values.every(
                            (value)=>{
                                return arr.includes(value) === true                          
                            } 
                        )
                    }
                )
                if (variante){
                    this.cartItem.variant = variante.id
                    this.cartItem.quantity = 1
                    this.cartItem.unitPrice = this.product.price
                    this.compareAtDisplay = this.product.compareAt
                    if(variante.hasDifPricing){
                        this.cartItem.unitPrice = variante.price
                        this.compareAtDisplay = variante.compareAt
                    }
                    
                } else {
                    this.cartItem.quantity = 1
                    this.cartItem.variant = null
                    this.cartItem.unitPrice = this.product.price
                }
            } else{
                this.saveButtonDisabled = true
            }
            
        },
        async sendItem(){
            this.addButtonLoad = true
            
            let msgErr = {
                resource:'notify',
                text:"Parece que ya tienes este mismo producto en la lista! ve al carro y editalo."
            }
            let msgSuccess = {
                resource: 'notify',
                text: 'Producto agregado a la lista!'
            }
            let resp = await postHandler(this.createCartItemUrl, this.cartItem, {error:msgErr, success:false})
            this.addButtonLoad = false
            this.prodDetailModal = false
            localStorage.setItem("cartCount", resp.data.cartCount)
            var event = document.createEvent("Event");
            event.initEvent("storage", true, true);
            window.dispatchEvent(event);
            this.$emit("addedItemToCart")
        },
    },
    watch:{
        product: function(obj){
            this.compareAtDisplay = obj.compareAt
            this.cartItem.product = obj.id
            this.cartItem.unitPrice = obj.price
            this.cartItem.quantity = 1
        }
    },


}
</script>

<style lang="scss" scoped>
.modal-add-to-list{
    border-radius: 20px;
    max-width:500px;
}
.compare-at{
    text-decoration: line-through;
}

.description-box{
    max-height:300px;
    overflow-y: scroll;
}
</style>